import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

interface TableChangeOwnerModalEvent {
  optionSelected: TableChangeOwnerModalAction;
  tableId?: string;
  eventAction?: "click" | "view";
}

export type TableChangeOwnerModalAction =
  | "confirm"
  | "cancel"
  | "success"
  | "error";

export function useEmitTableChangeOwnerModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, tableId, eventAction }: TableChangeOwnerModalEvent) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.TableChangeOwnerModal,
        optionSelected,
        eventAction: eventAction ?? "click",
        customTrackingFields: {
          table_id: tableId,
        },
      });
    },
    [accountId],
  );

  return { emit };
}
